import React, { FunctionComponent } from 'react'
import { useNavigate } from 'react-router'

import { useFormValidation } from '../../../hooks/adjustments/formValidation'
import {
  useProposalAdjustment,
  useProposalFormData,
} from '../../../hooks/adjustments/proposal'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { useUpButton } from '../../../infrastructure/routing'
import { QuoteManagementConfig } from '../../../state/configuration'
import { FormErrors } from '../../formBuilder'
import { FullPage } from '../../templates'

export interface QuoteManagementPageProps {
  config: QuoteManagementConfig
}

const tKey = TKey('pages.disclosure')

export const RenewalDisclosurePage: FunctionComponent<QuoteManagementPageProps> = ({
  config,
}) => {
  const { t } = useWriskTranslation()

  const navigate = useNavigate()
  const upButton = useUpButton({ url: '../..', id: 'renewal' })

  const data = useProposalFormData(config.form)

  const onSubmit = useProposalAdjustment({
    form: config.form,
    applyRating: true,
    onComplete: () => navigate('../..'),
  })

  const onValidateForm = useFormValidation({
    validationProfile: config.validationProfile,
    onSuccess: onSubmit.execute,
  })

  return (
    <FullPage
      pageId='disclosure-page'
      header={t(tKey('headers', config.id))}
      upButton={upButton}
    >
      <FormErrors
        id='quote-management'
        data={data}
        config={config.form}
        onSubmit={onValidateForm.execute}
        loading={onValidateForm.loading}
        tKey={TExtends(tKey, 'form')}
        t={t}
      />
    </FullPage>
  )
}
